import store from '@/store/index'

const H5_SESSION_TOKEN = 'H5_SESSION_TOKEN'
const H5_SESSION_REFRESH_TOKEN = 'H5_SESSION_REFRESH_TOKEN'

function getSessionValue (key) {
  try {
    return window.sessionStorage.getItem(key)
  } catch (e) {
    return null
  }
}

function setSessionValue (key, value) {
  try {
    if (value) {
      window.sessionStorage.setItem(key, value)
    }
  } catch (e) {}
}

export function setToken () {
  const tokenSearch = window.location.href.match(/(\?|&)token=([^&]*)(&|$)/i)
  const refreshTokenSearch = window.location.href.match(/(\?|&)refresh_token=([^&]*)(&|$)/i)
  let token = null
  let refreshToken = null

  if (tokenSearch && tokenSearch[2]) {
    token = decodeURIComponent(tokenSearch[2])
    setSessionValue(H5_SESSION_TOKEN, token)
  } else {
    token = getSessionValue(H5_SESSION_TOKEN)
  }

  if (refreshTokenSearch && refreshTokenSearch[2]) {
    refreshToken = decodeURIComponent(refreshTokenSearch[2])
    setSessionValue(H5_SESSION_REFRESH_TOKEN, refreshToken)
  } else {
    refreshToken = getSessionValue(H5_SESSION_REFRESH_TOKEN)
  }

  if (token) {
    store.dispatch('user/setToken', token)
  }

  if (refreshToken) {
    store.dispatch('user/setRefreshToken', refreshToken)
  }
}

export function getToken () {
  return {
    token: store.state.user.token || null,
    refreshToken: store.state.user.refreshToken || null,
  }
}

export function getRefreshToken () {
  return store.state.user.refreshToken || null
}

export function setTabBarHeight () {
  const tabBarHeight = window.location.href.match(/(\?|&)userId=([^&]*)(&|$)/i)

  if (tabBarHeight && tabBarHeight[2]) {
    store.dispatch('app/setTabHeight', {
      height: tabBarHeight[2],
    })
  }
}
